var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cert-hash"},[_c('div',{staticClass:"hash-info"},[_vm._v(_vm._s(_vm.$t('cert.hashInfo')))]),_c('div',{attrs:{"data-test":"cert-hash-value"}},[_vm._v(_vm._s(_vm._f("colonize")(_vm.hash)))])])}
var staticRenderFns = []

export { render, staticRenderFns }